import api from "../_api"

// Load carousel items to the store
const loadCarouselItems = (context) => {

    api.loadCarouselItems(context).then(response => {
        context.commit('updateCarouselItems', response.data)
    }).catch(
        (error) => { console.error(error) }
    )

}

export default {
    loadCarouselItems
}
